import { IntubationConstants } from '../store/intubation.constants'

export const intubationSchemas = [
  {
    inputKey: IntubationConstants.SET_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_DATE'],
    errorMessage: {
      properties: {
        SET_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: IntubationConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: IntubationConstants.SET_DECISION_TO_MANAGE_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DECISION_TO_MANAGE_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_DECISION_TO_MANAGE_DATE'],
    errorMessage: {
      properties: {
        SET_DECISION_TO_MANAGE_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: IntubationConstants.SET_DECISION_TO_MANAGE_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DECISION_TO_MANAGE_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_DECISION_TO_MANAGE_TIME'],
    errorMessage: {
      properties: {
        SET_DECISION_TO_MANAGE_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: IntubationConstants.SET_ABANDONED_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ABANDONED_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_ABANDONED_DATE'],
    errorMessage: {
      properties: {
        SET_ABANDONED_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: IntubationConstants.SET_ABANDONED_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ABANDONED_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_ABANDONED_TIME'],
    errorMessage: {
      properties: {
        SET_ABANDONED_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
]

export const intubationSecondsSchemas = [
  {
    inputKey: IntubationConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: IntubationConstants.SET_DECISION_TO_MANAGE_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DECISION_TO_MANAGE_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_DECISION_TO_MANAGE_TIME'],
    errorMessage: {
      properties: {
        SET_DECISION_TO_MANAGE_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: IntubationConstants.SET_ABANDONED_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ABANDONED_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_ABANDONED_TIME'],
    errorMessage: {
      properties: {
        SET_ABANDONED_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
]
